import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Users, ShoppingBag, Wallet, PieChart, FileText, LogOut, Zap, Menu, X,
} from "lucide-react";
import { useState } from "react";

const nav = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard-link", end: true },
  { to: "/talents", label: "Talent", icon: Users, testid: "nav-talents-link" },
  { to: "/sales", label: "Penjualan Afiliasi", icon: ShoppingBag, testid: "nav-sales-link" },
  { to: "/disbursements", label: "Disbursement", icon: Wallet, testid: "nav-disbursement-link" },
  { to: "/revenue-model", label: "Model Revenue", icon: PieChart, testid: "nav-revenue-model-link" },
  { to: "/reports", label: "Laporan & Export", icon: FileText, testid: "nav-reports-link" },
];

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-3 px-5 h-16 border-b border-border">
        <img src="/logo.png" alt="Komisia" className="h-9 w-9 rounded-lg shadow-lg shadow-primary/30" />
        <div>
          <p className="font-display font-bold text-sm leading-none">Komisia</p>
          <p className="text-[10px] text-muted-foreground mt-1">Affiliate Console</p>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {nav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={item.testid}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? "bg-primary/15 text-primary border border-primary/30"
                  : "text-muted-foreground hover:text-foreground hover:bg-card"
              }`
            }
          >
            <item.icon className="h-4.5 w-4.5 h-5 w-5" />
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-border">
        <div className="flex items-center gap-3 px-2 py-2 mb-2">
          <div className="h-9 w-9 rounded-full bg-secondary grid place-items-center text-sm font-semibold">
            {(user?.name || "A").charAt(0)}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium truncate">{user?.name}</p>
            <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          </div>
        </div>
        <button
          data-testid="logout-button"
          onClick={doLogout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-colors"
        >
          <LogOut className="h-5 w-5" /> Keluar
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex">
      <aside className="hidden lg:flex w-64 border-r border-border bg-[#0d121c] fixed inset-y-0">
        <SidebarContent />
      </aside>

      {open && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-64 bg-[#0d121c] border-r border-border">
            <button className="absolute top-4 right-4 text-muted-foreground" onClick={() => setOpen(false)}>
              <X className="h-5 w-5" />
            </button>
            <SidebarContent />
          </aside>
        </div>
      )}

      <div className="flex-1 lg:ml-64">
        <header className="lg:hidden flex items-center justify-between h-16 px-4 border-b border-border sticky top-0 bg-background/80 backdrop-blur z-30">
          <button onClick={() => setOpen(true)}><Menu className="h-6 w-6" /></button>
          <p className="font-display font-bold">Komisia</p>
          <div className="w-6" />
        </header>
        <main className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto">{children}</main>
      </div>
    </div>
  );
}
